// // Updated ProjectSelection.js
// import React from "react";
// import styles from "./OnboardProject.module.scss";
// import hospitalIcon from "../../assets/RpmAssets/hospitalicon.svg";
// import { bookmark } from "../../actions/RPMAction";
// import { SvgIcons } from "../../assets/svg-icons";
// import { useDispatch } from "react-redux";

// const ProjectSelection = ({
//   projects,
//   selectedProject,
//   onSelect,
//   profileName,
//   loading,
//   onBack,
// }) => {
//   const [bookmarkId, setBookmarkId] = React.useState(null);
//   const dispatch = useDispatch();

//   React.useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("userData"));
//     if (user) {
//       console.log("Selected project:", user.bookmarkclinic);
//       setBookmarkId(user.bookmarkclinic);
//     }
//   }, []);
//   function handleClickBookmark(isBookmarked, id) {
//     console.info("isBookmarked", isBookmarked);
//     console.info("id", id);
//     // dispatch(bookmark(profileId, id)).then((res) => {
//     //   console.info(res);
//     // });
//   }
//   return (
//     <div className={styles.stepContainer}>
//       <div className={styles.stepHeader}>
//         <h1>Welcome, {profileName}!</h1>
//         <p>Choose the project you want to access</p>
//       </div>

//       <div className={styles.projectGrid}>
//         {projects?.map((project) => (
//           <ProjectCard
//             key={project.clinic_Id}
//             project={project}
//             isSelected={selectedProject?.clinic_Id === project.clinic_Id}
//             onSelect={() => onSelect(project)}
//             disabled={loading}
//             isBookmarked={bookmarkId === project.clinic_Id}
//             handleClickBookmark={() =>
//               handleClickBookmark(
//                 !(bookmarkId === project.clinic_Id),
//                 project.clinic_Id
//               )
//             }
//           />
//         ))}
//       </div>

//       {selectedProject && (
//         <div className={styles.stepActions}>
//           <button
//             className={styles.nextButton}
//             onClick={() => onSelect(selectedProject)}
//             disabled={loading}
//           >
//             {loading ? "Loading..." : "Continue →"}
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// const ProjectCard = ({
//   project,
//   isSelected,
//   onSelect,
//   disabled,
//   isBookmarked,
//   handleClickBookmark,
// }) => {
//   console.log("project===>", project);
//   return (
//     <div
//       className={`${styles.projectCard} ${isSelected ? styles.selected : ""} ${disabled ? styles.disabled : ""}`}
//       onClick={!disabled ? onSelect : undefined}
//     >
//       <div className={styles.projectLogo}>
//         <img
//           src={project.logo || hospitalIcon}
//           alt={project.clinicName}
//           onError={(e) => {
//             e.target.src = "/default-hospital-icon.svg";
//           }}
//         />
//       </div>
//       <div className={styles.projectInfo}>
//         <h3>{project.clinicName}</h3>
//         {project.description && (
//           <p className={styles.projectDescription}>{project.description}</p>
//         )}
//       </div>
//       <div>
//         <button onClick={handleClickBookmark}>
//           {isBookmarked ? (
//             <SvgIcons.BookMarkIconFilled />
//           ) : (
//             <SvgIcons.BookMarkIcon />
//           )}
//         </button>
//       </div>
//       <div className={styles.projectArrow}>→</div>
//     </div>
//   );
// };

// export default ProjectSelection;
import React from "react";
import styles from "./OnboardProject.module.scss";
import hospitalIcon from "../../assets/RpmAssets/hospitalicon.svg";
import { bookmark } from "../../actions/RPMAction";
import { SvgIcons } from "../../assets/svg-icons";
import { useDispatch } from "react-redux";

const ProjectSelection = ({
  projects,
  selectedProject,
  onSelect,
  profileName,
  loading,
  onBack,
}) => {
  const [bookmarkId, setBookmarkId] = React.useState(null);
  const [profileId, setProfileId] = React.useState(null);
  const dispatch = useDispatch();

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userData"));
    if (user) {
      setBookmarkId(user.bookmarkclinic); // only one can be bookmarked
      setProfileId(user.userId); // assuming this is your profileId key
    }
  }, []);

  async function handleClickBookmark(isBookmarked, id) {
    // Call action only if changing
    console.log(profileId, id, isBookmarked, "profileId==================");

    if (isBookmarked) {
      // Set bookmark: only one possible
      setBookmarkId(id);

      // Optionally update user data in localStorage
      const user = JSON.parse(localStorage.getItem("userData")) || {};
      user.bookmarkclinic = id;
      localStorage.setItem("userData", JSON.stringify(user));

      await dispatch(bookmark(profileId, id));
    } else {
      // Remove bookmark
      setBookmarkId(null);
      const user = JSON.parse(localStorage.getItem("userData")) || {};
      user.bookmarkclinic = null;
      localStorage.setItem("userData", JSON.stringify(user));

      await dispatch(bookmark(profileId, null));
    }
  }

  return (
    <div className={styles.stepContainer}>
      <div className={styles.stepHeader}>
        <h1>Welcome, {profileName}!</h1>
        <p>Choose the project you want to access</p>
      </div>
      <div className={styles.projectGrid}>
        {projects?.map((project) => (
          <ProjectCard
            key={project.clinic_Id}
            project={project}
            isSelected={selectedProject?.clinic_Id === project.clinic_Id}
            onSelect={() => onSelect(project)}
            disabled={loading}
            isBookmarked={bookmarkId === project.clinic_Id}
            handleClickBookmark={() =>
              handleClickBookmark(
                !(bookmarkId === project.clinic_Id),
                project.clinic_Id
              )
            }
          />
        ))}
      </div>
      {selectedProject && (
        <div className={styles.stepActions}>
          <button
            className={styles.nextButton}
            onClick={() => onSelect(selectedProject)}
            disabled={loading}
          >
            {loading ? "Loading..." : "Continue →"}
          </button>
        </div>
      )}
    </div>
  );
};

const ProjectCard = ({
  project,
  isSelected,
  onSelect,
  disabled,
  isBookmarked,
  handleClickBookmark,
}) => {
  return (
    <div
      className={[
        styles.projectCard,
        isSelected ? styles.selected : "",
        disabled ? styles.disabled : "",
      ].join(" ")}
      onClick={!disabled ? onSelect : undefined}
    >
      <div className={styles.projectLogo}>
        <img
          src={project.logo || hospitalIcon}
          alt={project.clinicName}
          onError={(e) => {
            e.target.src = "/default-hospital-icon.svg";
          }}
        />
      </div>
      <div className={styles.projectInfo}>
        <h3>{project.clinicName}</h3>
        {project.description && (
          <p className={styles.projectDescription}>{project.description}</p>
        )}
      </div>
      {/* <div>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation(); // Prevent select on icon click
            handleClickBookmark();
          }}
        >
          {isBookmarked ? (
            <SvgIcons.BookMarkIconFilled />
          ) : (
            <SvgIcons.BookMarkIcon />
          )}
        </button>
      </div> */}
      <div className={styles.projectArrow}>→</div>
    </div>
  );
};

export default ProjectSelection;
